import React, { useState } from 'react'
import qr_code from "../assets/images/icons/qr_code_22px.svg"
import money_increases from "../assets/images/icons/money_increases_22px.svg"
import shield_checked from "../assets/images/icons/shield_check_22px.svg"
import golf_goal from "../assets/images/icons/golf_goal_22px.svg"
import heart_broken from "../assets/images/icons/heart_broken_22px.svg"
import education from "../assets/images/icons/education_22px.svg"
import cheveron_down from "../assets/images/icons/cheveron_down_22px.svg"
import { useTranslation } from 'react-i18next'
import { StyledLinkDom, StyledLinkDomWhiteIndustries } from './StyledLinkDom'


const IndustriesStickyMenu = (props) => {
  const { t } = useTranslation()

  const [generalIsChecked, setGeneralIsChecked] = useState(props.generalActive);
  const [bankingIsChecked, setBankingIsChecked] = useState(props.bankingAndFinancialActive);
  const [insuranceIsChecked, setInsuranceIsChecked] = useState(props.insuranceActive);
  const [govtIsChecked, setGovtIsChecked] = useState(props.governmentActive);
  const [healthcareIsChecked, setHealthcareIsChecked] = useState(props.healthcareActive);
  const [educationIsChecked, setEducationIsChecked] = useState(props.educationActive);

  const handleGeneralCheckboxChange = () => {
    setGeneralIsChecked(!generalIsChecked);
  };

  const handleBankingCheckboxChange = () => {
    setBankingIsChecked(!bankingIsChecked);
  };

  const handleInsuranceCheckboxChange = () => {
    setInsuranceIsChecked(!insuranceIsChecked);
  };

  const handleGovtCheckboxChange = () => {
    setGovtIsChecked(!govtIsChecked);
  };

  const handleHealthcareCheckboxChange = () => {
    setHealthcareIsChecked(!healthcareIsChecked);
  };

  const handleEducationCheckboxChange = () => {
    setEducationIsChecked(!educationIsChecked);
  };

  return (
    <div className='industries-sticky-menu'>
      <ul className='industries-sticky-menu_list list-unstyled'>
        <li className='industries-sticky-menu_list__items'>
          <div className='flex justify-spacebetween align-center'>
            <StyledLinkDomWhiteIndustries to="/industries/general-and-hr" className={`flex align-center justify-center ${props.generalActive ? 'active' : ""}`}>
              <img src={qr_code} alt="" className='mr-8' />
              <p className='font-weight-medium'>{t('industries-sticky-menu.general')}</p>
            </StyledLinkDomWhiteIndustries>
            <label htmlFor="General" className='mt-10' style={{ cursor: "pointer" }}>
              <img src={cheveron_down} alt="cheveron_down" className={generalIsChecked ? "reverse-icon" : 'unreverse-icon'} />
            </label>
          </div>
          <input type="checkbox" className="industries-dropdown hidden" id="General" onChange={handleGeneralCheckboxChange} />
          {generalIsChecked && (
            <ul className='industries-sticky-menu_mini_list list-unstyled pt-10'>
              <StyledLinkDom to="/industries/invoices-and-bills">
                <li className={`industries-sticky-menu_mini_list__items ${props.invoicesAndBillsActive ? "active" : ""}`}>
                  {t('industries-sticky-menu.invoices-and-bills')}
                </li>
              </StyledLinkDom>
              <StyledLinkDom to="/industries/hr-and-payroll">
                <li className={`industries-sticky-menu_mini_list__items ${props.hrAndPayrollActive ? "active" : ""}`}>
                  {t('industries-sticky-menu.hr-and-payroll')}
                </li>
              </StyledLinkDom>
            </ul>
          )}
        </li>
        <li className='industries-sticky-menu_list__items'>
          <div className='flex justify-spacebetween align-center'>
            <StyledLinkDomWhiteIndustries to="/industries/banking-and-financial" className={`flex align-center justify-center ${props.bankingAndFinancialActive ? 'active' : ""}`}>
              <img src={money_increases} alt="" className='mr-8' />
              <p className='font-weight-medium'>{t('industries-sticky-menu.banking-and-financial')}</p>
            </StyledLinkDomWhiteIndustries>
            <label htmlFor="BankingFinancial" className='mt-10' style={{ cursor: "pointer" }}>
              <img src={cheveron_down} alt="cheveron_down" className={bankingIsChecked ? "reverse-icon" : 'unreverse-icon'} />
            </label>
          </div>
          <input type="checkbox" className="industries-dropdown hidden" id="BankingFinancial" onChange={handleBankingCheckboxChange} />
          {bankingIsChecked && (
            <ul className='industries-sticky-menu_mini_list list-unstyled pt-10'>
              <StyledLinkDom to="/industries/account-statements">
                <li className={`industries-sticky-menu_mini_list__items ${props.accountStatementsActive ? "active" : ""}`}>{t('industries-sticky-menu.account-statements')}</li>
              </StyledLinkDom>
              <StyledLinkDom to="/industries/cheques">
                <li className={`industries-sticky-menu_mini_list__items ${props.chequesActive ? "active" : ""}`}>{t('industries-sticky-menu.cheques')}</li>
              </StyledLinkDom>
              <StyledLinkDom to="/industries/trade-finance-documents">
                <li className={`industries-sticky-menu_mini_list__items ${props.tradeFinancialDocumentsActive ? "active" : ""}`}>{t('industries-sticky-menu.trade-finance-document')}</li>
              </StyledLinkDom>
            </ul>
          )}
        </li>
        <li className='industries-sticky-menu_list__items'>
          <div className='flex justify-spacebetween align-center'>
            <StyledLinkDomWhiteIndustries to="/industries/insurance" className={`flex align-center justify-center ${props.insuranceActive ? 'active' : ""}`}>
              <img src={shield_checked} alt="" className='mr-8' />
              <p className='font-weight-medium'>{t('industries-sticky-menu.insurance')}</p>
            </StyledLinkDomWhiteIndustries>
            <label htmlFor="Insurance" className='mt-10' style={{ cursor: "pointer" }}>
              <img src={cheveron_down} alt="cheveron_down" className={insuranceIsChecked ? "reverse-icon" : 'unreverse-icon'} />
            </label>
          </div>
          <input type="checkbox" className="industries-dropdown hidden" id="Insurance" onChange={handleInsuranceCheckboxChange} />
          {insuranceIsChecked && (
            <ul className='industries-sticky-menu_mini_list list-unstyled pt-10'>
              <StyledLinkDom to="/industries/insurance-medical-claims">
                <li className={`industries-sticky-menu_mini_list__items ${props.medicalClaimsActive ? "active" : ""}`}>{t('industries-sticky-menu.medical-claims')}</li>
              </StyledLinkDom>
              <StyledLinkDom to="/industries/insurance-membership-cards">
                <li className={`industries-sticky-menu_mini_list__items ${props.membershipCardsActive ? "active" : ""}`}>{t('industries-sticky-menu.membership-cards')}</li>
              </StyledLinkDom>
              <StyledLinkDom to="/industries/insurance-policy-documents">
                <li className={`industries-sticky-menu_mini_list__items ${props.policyDocumentsActive ? "active" : ""}`}>{t('industries-sticky-menu.policy-documents')}</li>
              </StyledLinkDom>
            </ul>
          )}
        </li>
        <li className='industries-sticky-menu_list__items'>
          <div className='flex justify-spacebetween align-center'>
            <StyledLinkDomWhiteIndustries to="/industries/government" className={`flex align-center justify-center ${props.governmentActive ? 'active' : ""}`}>
              <img src={golf_goal} alt="" className='mr-8' />
              <p className='font-weight-medium'>{t('industries-sticky-menu.govt-and-regulators')}</p>
            </StyledLinkDomWhiteIndustries>
            <label htmlFor="Govt" className='mt-10' style={{ cursor: "pointer" }}>
              <img src={cheveron_down} alt="cheveron_down" className={govtIsChecked ? "reverse-icon" : 'unreverse-icon'} />
            </label>
          </div>
          <input type="checkbox" className="industries-dropdown hidden" id="Govt" onChange={handleGovtCheckboxChange} />
          {govtIsChecked && (
            <ul className='industries-sticky-menu_mini_list list-unstyled pt-10'>
              <StyledLinkDom to="/industries/certificates-permits-licenses">
                <li className={`industries-sticky-menu_mini_list__items ${props.certificatesPermitsLicensesActive ? "active" : ""}`} style={{paddingRight:"50px"}}>{t('industries-sticky-menu.certificates-premits-and-licenses')}</li>
              </StyledLinkDom>
              <StyledLinkDom to="/industries/identity-cards">
                <li className={`industries-sticky-menu_mini_list__items ${props.identityCardsActive ? "active" : ""}`}>{t('industries-sticky-menu.identity-cards')}</li>
              </StyledLinkDom>
              <StyledLinkDom to="/industries/immigration">
                <li className={`industries-sticky-menu_mini_list__items ${props.immigrationActive ? "active" : ""}`}>{t('industries-sticky-menu.immigration')}</li>
              </StyledLinkDom>
              <StyledLinkDom to="/industries/taxation">
                <li className={`industries-sticky-menu_mini_list__items ${props.taxationActive ? "active" : ""}`}>{t('industries-sticky-menu.taxation')}</li>
              </StyledLinkDom>
            </ul>
          )}
        </li>
        <li className='industries-sticky-menu_list__items'>
          <div className='flex justify-spacebetween align-center'>
            <StyledLinkDomWhiteIndustries to="/industries/healthcare" className={`flex align-center justify-center ${props.healthcareActive ? 'active' : ""}`}>
              <img src={heart_broken} alt="" className='mr-8' />
              <p className='font-weight-medium'>{t('industries-sticky-menu.healthcare')}</p>
            </StyledLinkDomWhiteIndustries>
            <label htmlFor="Healthcare" className='mt-10' style={{ cursor: "pointer" }}>
              <img src={cheveron_down} alt="cheveron_down" className={healthcareIsChecked ? "reverse-icon" : 'unreverse-icon'} />
            </label>
          </div>
          <input type="checkbox" className="industries-dropdown hidden" id="Healthcare" onChange={handleHealthcareCheckboxChange} />
          {healthcareIsChecked && (
            <ul className='industries-sticky-menu_mini_list list-unstyled pt-10'>
              <StyledLinkDom to="/industries/lab-reports/">
                <li className={`industries-sticky-menu_mini_list__items ${props.labReportsActive ? "active" : ""}`}>{t('industries-sticky-menu.lab-reports')}</li>
              </StyledLinkDom>
            </ul>
          )}
        </li>
        <li className='industries-sticky-menu_list__items'>
          <div className='flex justify-spacebetween align-center'>
            <StyledLinkDomWhiteIndustries to="/industries/education" className={`flex align-center justify-center ${props.educationActive ? 'active' : ""}`}>
              <img src={education} alt="" className='mr-8' />
              <p className='font-weight-medium'>{t('industries-sticky-menu.education')}</p>
            </StyledLinkDomWhiteIndustries>
            <label htmlFor="Education" className='mt-10' style={{ cursor: "pointer" }}>
              <img src={cheveron_down} alt="cheveron_down" className={educationIsChecked ? "reverse-icon" : 'unreverse-icon'} />
            </label>
          </div>
          <input type="checkbox" className="industries-dropdown hidden" id="Education" onChange={handleEducationCheckboxChange} />
          {educationIsChecked && (
            <ul className='industries-sticky-menu_mini_list list-unstyled pt-10'>
              <StyledLinkDom to="/industries/university-degrees-and-transcripts">
                <li className={`industries-sticky-menu_mini_list__items ${props.universityDegreesActive ? "active" : ""}`}>{t('industries-sticky-menu.university-degrees-and-transcripts')}</li>
              </StyledLinkDom>
            </ul>
          )}
        </li>
      </ul>
    </div>
  )
}

export default IndustriesStickyMenu